import { aspectRatios } from 'data/aspect-ratios';
import { useAtom } from 'jotai';
import { classNames } from 'lib/generic-utils';
import { useTheme } from './ThemeProvider';
import { aspectRatioAtom } from './atoms/animationFormAtoms';

const AspectRatioToggle = () => {

  const [aspectRatio, setAspectRatio] = useAtom(aspectRatioAtom);

  const scaleBy = 24 / 768;
  const { theme } = useTheme();

  return (
    <div className="grid grid-cols-3 max-w-xs gap-x-4">
      {
        aspectRatios.map((ar) => <div
          key={ar.label}
          onClick={() => {
            setAspectRatio(ar);
          }}
          color={"light"}
          className={classNames(ar.label === aspectRatio.label ? "shadow-solid-around  dark:shadow-dark-solid-around text-black dark:text-white " : ' text-neutral-700 dark:text-neutral-400',
            'rounded-none border-solid border-2 bg-white border-neutral-400 dark:bg-black dark:border-neutral-700')}>
            <div className="flex justify-center items-center gap-2 h-full w-full p-1">
              <div>{ar.label}</div>
              <div>
                <svg width={ar.width * scaleBy} height={ar.height * scaleBy} xmlns="http://www.w3.org/2000/svg">
                  <rect width={ar.width * scaleBy} height={ar.height * scaleBy}
                    rx="5" fill={theme === 'dark' ? 'white' : 'gray'} strokeWidth="2" fillOpacity={ar.label === aspectRatio.label ? 0.25 : 0}
                    stroke={theme === 'dark' ? 'white' : 'black'} strokeOpacity={ar.label === aspectRatio.label ? 1 : 0.8} />

                  <rect x={(ar.width * scaleBy) / 2 - 2} y={(ar.height * scaleBy) / 2 - 2} width={4} height={4}
                    fill={theme === 'dark' ? 'white' : 'black'} strokeWidth="2" fillOpacity={ar.label === aspectRatio.label ? 1 : 0}
                    stroke={theme === 'dark' ? 'white' : 'black'} strokeOpacity={ar.label === aspectRatio.label ? 1 : 0} />

                </svg>
              </div>
            </div>
        </div>)
      }

    </div>
  );
};

export default AspectRatioToggle;